export const SOCIAL_CARDS = [
  {
    description:
      'Bulletproof focus formula: <br /> <br /> Pomodorro timer + Noise-cancelling headphones with <span>@brainfmapp</span> on + Notifications off + At least 20 min cardio in the morning = Any task is done 3 times faster',
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-alex-popova.png',
    username: '@alex_popova',
    name: 'Alex Popova',
  },
  {
    description: `I've just discovered <span>@brainfmapp</span> <br /> <br /> It's a literal cure for my ADHD. <br /> <br /> Just came out of a 4.5hr deep work session. <br /> <br />Truly am amazed, usually can't concentrate for longer than 30mins. <br /> <br />Game changer`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-ben-simpson.png',
    username: '@bensimpsonau',
    name: 'Ben Simpson',
  },
  {
    description: `<span>@BrainfmApp</span> = Zen Work Mode`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-akaash-joshi.png',
    username: '@scaleegod',
    name: 'Akaash Joshi',
  },
  {
    description: `Listening to <span>@BrainfmApp</span> <br/>supercharges my productivity. It helps me going into a deep flow state whenever I want. You heard right: whenever I want.`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-nico.png',
    username: '@nicotfl',
    name: 'Nico',
  },
  {
    description: `<span>@brainfmapp</span> has been a great ally to my productivity in the last couple of years as a Software Developer. <br/><br/>As a Ghostwriter, it 10x my productivity without a doubt. <br/> <br/> Try it!`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-romulo-alves.png',
    username: '@romuloaalves',
    name: 'Rômulo Alves',
  },
  {
    description: `Honestly what's really great for me when working/deep focus task - especially as someone with ADHD is <span>@BrainfmApp</span>.`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-robot-bear.png',
    username: '@iamrobotbear',
    name: 'robotbear.eth',
  },
  {
    description: `I’m obsessed with increasing focus and getting productivity gains. I must say Brain.fm is worth every penny I have paid for it. Flow state instantly activated.`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-dappadan.png',
    name: 'Dappadan',
  },
  {
    description: `I’m an adult with ADHD. I’ve seen a huge difference in my ability to focus when I listen to the highest neural effect setting with my noise-canceling headphones. I’m so glad this app exists! ❤️`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-morri-b.png',
    name: 'Morri B.',
  },
];

export const MUSIC_TASK_LIST = [
  {
    title: 'Deep Work',
    description: 'Designed for demanding tasks that require sustained periods of intense focus.',
    imageSrc: 'https://cdn.brain.fm/images/adhd/music-deep-work.png',
  },
  {
    title: 'Creativity',
    description:
      'Music designed to engage and inspire. Use it to help with creative design, ideation, or expression.',
    imageSrc: 'https://cdn.brain.fm/images/adhd/music-creativity.png',
  },
  {
    title: 'Learning',
    description: 'This music helps with knowledge retention or long periods of reading.',
    imageSrc: 'https://cdn.brain.fm/images/adhd/music-learning.png',
  },
  {
    title: 'Light Work',
    description: 'Created for multiple less-demanding tasks to be done in quick succession.',
    imageSrc: 'https://cdn.brain.fm/images/adhd/music-light-work.png',
  },
  {
    title: 'Motivation',
    description:
      'Energizing and upbeat, this music has been curated to enhance your drive and concentration.',
    imageSrc: 'https://cdn.brain.fm/images/adhd/music-motivation.png',
  },
];

export const GENRE_LIST_1 = [
  {
    title: 'LoFi',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-lofi-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/lofi-large.png',
  },
  {
    title: 'Electronic',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-electronic-bg.webp',
    iconImageSrc: 'https://cdn.brain.fm/icons/electronic-large.png',
  },
  {
    title: 'Atmospheric',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-atmospheric-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/atmospheric-large.png',
  },
  {
    title: 'Forest',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-forest-bg.webp',
    iconImageSrc: 'https://cdn.brain.fm/icons/forest-large.png',
  },
  {
    title: 'Acoustic',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-acoustic-bg.webp',
    iconImageSrc: 'https://cdn.brain.fm/icons/acoustic-large.png',
  },
  {
    title: 'Drone',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-drone-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/drone-large.png',
  },
  {
    title: 'Piano',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-piano-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/piano-large.png',
  },
  {
    title: 'Post Rock',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-post-rock-bg.webp',
    iconImageSrc: 'https://cdn.brain.fm/icons/post_rock-large.png',
  },
  {
    title: 'Rainforest',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-rainforest-bg.webp',
    iconImageSrc: 'https://cdn.brain.fm/icons/rain_forest-large.png',
  },
  {
    title: 'River',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-river-bg.webp',
    iconImageSrc: 'https://cdn.brain.fm/icons/river-large.png',
  },
];

export const GENRE_LIST_2 = [
  {
    title: 'Chimes & Bowls',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-chimes-bowls-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/chimes_and_bowls-large.png',
  },
  {
    title: 'Grooves',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-grooves-bg.webp',
    iconImageSrc: 'https://cdn.brain.fm/icons/grooves-large.png',
  },
  {
    title: 'Cinematic',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-cinematic-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/cinematic-large.png',
  },
  {
    title: 'Classical',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-classical-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/classical-large.png',
  },
  {
    title: 'Beach',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-beach-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/beach-large.png',
  },
  {
    title: 'NightSounds',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-nightsounds-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/night-large.png',
  },
  {
    title: 'Wind',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-wind-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/wind-large.png',
  },
  {
    title: 'Rain',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-rain-bg.webp',
    iconImageSrc: 'https://cdn.brain.fm/icons/rain-large.png',
  },
  {
    title: 'Thunder',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-thunder-bg.png',
    iconImageSrc: 'https://cdn.brain.fm/icons/thunder-large.png',
  },
  {
    title: 'Underwater',
    imageSrc: 'https://cdn.brain.fm/images/adhd/genre-underwater-bg.webp',
    iconImageSrc: 'https://cdn.brain.fm/icons/underwater-large.png',
  },
];
